<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <form @submit.prevent="resetPassword">
          <div slot="no-body" class="full-page-bg-color">
            <div class="vx-row">
              <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
              </div>
              <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">{{ $t('ResetPassword') }}</h4>
                  </div>
                  <vs-input type="password" label-placeholder="Password" v-model="password" class="w-full mb-6" />
                  <vs-input type="password" label-placeholder="Confirm Password" v-model="confirmPassword" class="w-full mb-8" />

                  <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                    <vs-button type="border" to="/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">{{ $t('Go Back To Login') }}</vs-button>
                    <vs-button class="w-full sm:w-auto" @click="resetPassword">{{ $t('Reset') }}</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </vx-card>
    </div>
</div>
</template>

<script>
import axios from '../../axios'
import i18n from '@/i18n/i18n'

export default {
  data () {
    return {
      password: '',
      confirmPassword: ''
    }
  },
  created () {
    console.log()
  },
  methods: {
    async resetPassword () {
      if (this.password != this.confirmPassword) {
        this.$vs.notify({
            title: 'Error',
            text: i18n.t('SamePassword'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
        return
      }
      try {
        const payload = {
          password: this.password,
          token: this.$route.query.token
        }
        this.$vs.loading()
        await axios.post('/auth/tenant/reset-password', payload)
        this.$vs.loading.close()
        this.$router.push('/login')
      } catch (e) {
        this.$vs.loading.close()
        this.$vs.notify({
            title: 'Error',
            text: e.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      }
    }
  }
}
</script>
